import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../auth/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }

    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        localStorage.setItem("wp_token", r.data.access_token);
        setUser(r.data.user);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/app", { replace: true, state: { user: r.data.user } });
      })
      .catch(() => {
        setError("Google sign-in could not be completed. Redirecting you back…");
        setTimeout(() => navigate("/login", { replace: true }), 2500);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#08080A]" data-testid="auth-callback">
      <div className="text-center">
        {error ? (
          <p className="text-sm text-red-400" data-testid="auth-callback-error">{error}</p>
        ) : (
          <>
            <span className="mx-auto block h-6 w-6 animate-spin rounded-full border-2 border-[#D4AF37]/30 border-t-[#D4AF37]" />
            <p className="mt-4 font-mono text-xs tracking-[0.25em] text-[#636B78] uppercase">
              Completing sign-in…
            </p>
          </>
        )}
      </div>
    </div>
  );
}
